import React from 'react';
import { Divider, Text } from '@razorpay/blade/components';
import { Box } from '@razorpay/blade/components';

interface SectionWrapperProps {
  title: string;
  description: string;
  children: React.ReactNode;
  showDivider?: boolean;
}

export const SectionWrapper = ({
  title,
  description,
  children,
  showDivider = true,
}: SectionWrapperProps) => (
  <>
    <Box display="flex" gap="spacing.8">
      <Box display="flex" flexDirection="column" gap="spacing.3" width="40%" minWidth="40%">
        <Text weight="semibold" size="medium">
          {title}
        </Text>
        <Text variant="body" size="small" color="surface.text.gray.muted">
          {description}
        </Text>
      </Box>

      <Box display="flex" flexDirection="column" gap="spacing.7" flexGrow={1}>
        {children}
      </Box>
    </Box>
    {showDivider && <Divider marginY="spacing.8" />}
  </>
);
